import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { isDataAs, useQuestionSuggestions } from "@me8eon/async";
import { useOnceWhen } from "@me8eon/debounce";
import { useAsyncSessionAndMessages, useMakeNewSession } from "@me8eon/sessions_messages";
import { useLoadingOrError } from "@me8eon/components";
import { useUserData } from "@me8eon/react_authentication";
import AiAssistantPage from "./AiAssistant.page";
import { Banner } from "../../components/banner/Banner";

export default function AiSharePage() {
    const { featureFlagEnabled } = useUserData();

    if (featureFlagEnabled) {
        return <Navigate to="/new-ai" replace />;
    }

    const [state] = useAsyncSessionAndMessages();
    const makeNewSession = useMakeNewSession();
    const [, setQs] = useQuestionSuggestions();
    const LoadingOrError = useLoadingOrError();
    const [isNewSession, setIsNewSession] = useState(false);

    useOnceWhen(isDataAs(state), () => {
        const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
        const isPageReload = navEntry?.type === "reload";
        if (!isPageReload) {
            makeNewSession("");
            setQs([]);
        }
        setIsNewSession(true);
    });

    return (
        <>
            {window.location.pathname === "/ai" && <Banner />}
            {isNewSession ? (
                <LoadingOrError
                    state={state}
                    whatWeAreLoading={"Loading Chat"}
                    rootId="sessions-and-messages"
                    showChildAnyway={true}
                >
                    {() => <AiAssistantPage />}
                </LoadingOrError>
            ) : (
                <div>Loading chat...</div>
            )}
        </>
    );
}
